var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHourglassLow = function SvgIconHourglassLow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5 20.25A1.75 1.75 0 0 0 6.75 22h10.5A1.75 1.75 0 0 0 19 20.25v-3.344a1.76 1.76 0 0 0-.695-1.39l-.002-.001L13.657 12l4.648-3.516A1.76 1.76 0 0 0 19 7.094V3.75A1.75 1.75 0 0 0 17.25 2H6.75A1.75 1.75 0 0 0 5 3.75v3.381a1.76 1.76 0 0 0 .695 1.39l.005.004L10.333 12l-4.638 3.479A1.76 1.76 0 0 0 5 16.869v3.381m10.96-4-3.963-2.998L8 16.25zm1.04 2V20H7v-1.75zM7 7l4.997 3.748L17 6.963V4H7z",
    clipRule: "evenodd"
  })));
};
export default SvgIconHourglassLow;